'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosFolderOutline = function IoIosFolderOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.2 7.5c1 0 1.8 0.8 1.8 1.8v23.7c0 1.1-0.8 2-1.8 2h-31.2c-1.1 0-2-0.9-2-2v-26.2c0-1 0.9-1.8 2-1.8h8.7c0.6 0 0.9 0.2 1.3 0.5l1.8 1.8c0.2 0.2 0.3 0.2 0.5 0.2h18.9z m-31.2-1.2c-0.4 0-0.7 0.2-0.7 0.5v5.8c0.2-0.1 0.3-0.1 0.6-0.1h31.2c0.3 0 0.4 0 0.7 0.1v-3.3c0-0.3-0.3-0.5-0.6-0.5h-18.9c-0.5 0-0.9-0.2-1.3-0.6l-1.8-1.8c-0.2-0.1-0.3-0.1-0.5-0.1h-8.8z m31.8 26.7v-18.6c0-0.3-0.4-0.6-0.7-0.6h-31.2c-0.3 0-0.6 0.3-0.6 0.6v18.6c0 0.4 0.3 0.8 0.7 0.8h31.2c0.3 0 0.6-0.4 0.6-0.8z' })
        )
    );
};

exports.default = IoIosFolderOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-folder-outline.js
// module id = 2193
// module chunks = 0